import { render, staticRenderFns } from "./TickerAdminAddOption.vue?vue&type=template&id=16f7da4a&scoped=true"
import script from "./TickerAdminAddOption.vue?vue&type=script&lang=js"
export * from "./TickerAdminAddOption.vue?vue&type=script&lang=js"
import style0 from "./TickerAdminAddOption.vue?vue&type=style&index=0&id=16f7da4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f7da4a",
  null
  
)

export default component.exports